(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["footer"]) return;
  try {
    
  document.querySelectorAll('[data-footer-accordion] .site-footer__trigger, .site-footer .site-footer__trigger').forEach((button) => {
    button.addEventListener('click', () => {
      if (window.matchMedia('(min-width: 990px)').matches) return;
      const col = button.closest('.site-footer__col');
      if (!col || col.classList.contains('site-footer__col--signup')) return;
      const open = col.classList.toggle('is-open');
      button.setAttribute('aria-expanded', open ? 'true' : 'false');
    });
  });

  document.querySelectorAll('[data-ge-news]').forEach((root) => {
    const setChannel = (channel) => {
      root.setAttribute('data-channel', channel);
      root.querySelectorAll('[data-ge-news-tab]').forEach((tab) => {
        const on = tab.getAttribute('data-ge-news-tab') === channel;
        tab.classList.toggle('is-active', on);
        tab.setAttribute('aria-selected', on ? 'true' : 'false');
      });
      root.querySelectorAll('[data-ge-news-panel]').forEach((panel) => {
        const on = panel.getAttribute('data-ge-news-panel') === channel;
        panel.hidden = !on;
      });
    };
    root.querySelectorAll('[data-ge-news-tab]').forEach((tab) => {
      tab.addEventListener('click', () => setChannel(tab.getAttribute('data-ge-news-tab')));
    });
    const sms = root.querySelector('[data-ge-news-sms]');
    if (sms) {
      sms.addEventListener('submit', (event) => {
        event.preventDefault();
      });
    }
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["skincare-faq"] && !Shopify.designMode) return;
  try {
    
(() => {
  const bind = (root) => {
    const scope = root && root.querySelectorAll ? root : document;
    scope.querySelectorAll('[data-ge-skin-faq] [data-sr-faq-toggle]').forEach((button) => {
      if (button.dataset.skinFaqBound === 'true') return;
      button.dataset.skinFaqBound = 'true';
      const panelId = button.getAttribute('aria-controls');
      const panel = panelId ? document.getElementById(panelId) : null;
      if (!panel) return;
      const setOpen = (open) => {
        button.setAttribute('aria-expanded', open ? 'true' : 'false');
        button.classList.toggle('is-open', open);
        panel.hidden = !open;
      };
      setOpen(false);
      button.addEventListener('click', (event) => {
        event.stopImmediatePropagation();
        setOpen(button.getAttribute('aria-expanded') !== 'true');
      }, true);
    });
  };
  bind(document);
  document.addEventListener('shopify:section:load', (event) => bind(event.target));
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["skincare-key-ingredients"] && !Shopify.designMode) return;
  try {
    
(() => {
  const bind = (root) => {
    const scope = root && root.querySelectorAll ? root : document;
    scope.querySelectorAll('[data-ge-key-ingredients] [data-sr-faq-toggle]').forEach((button) => {
      if (button.dataset.keyIngredientBound === 'true') return;
      button.dataset.keyIngredientBound = 'true';
      const panelId = button.getAttribute('aria-controls');
      const panel = panelId ? document.getElementById(panelId) : null;
      if (!panel) return;
      const setOpen = (open) => {
        button.setAttribute('aria-expanded', open ? 'true' : 'false');
        button.classList.toggle('is-open', open);
        panel.hidden = !open;
      };
      setOpen(false);
      button.addEventListener('click', (event) => {
        event.stopImmediatePropagation();
        setOpen(button.getAttribute('aria-expanded') !== 'true');
      }, true);
    });
  };
  bind(document);
  document.addEventListener('shopify:section:load', (event) => bind(event.target));
})();

  } catch(e) { console.error(e); }
})();
})();
